import { render, staticRenderFns } from "./Pools.vue?vue&type=template&id=0286348a&scoped=true&"
import script from "./Pools.vue?vue&type=script&lang=ts&"
export * from "./Pools.vue?vue&type=script&lang=ts&"
import style0 from "./Pools.vue?vue&type=style&index=0&id=0286348a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286348a",
  null
  
)

export default component.exports